export type LoginViewTranslation = {
  title: string;
  loading: string;
  buttons: {
    start: string;
    continue: string;
    login: string
  };
  toast: {
    loginError: string;
    unknownError: string;
  };
  welcomeFirst: {
    title: string;
    message: string;
  };
  welcomeAdmin: {
    title: string;
    message: string;
  };
  welcomeAgain: {
    title: string;
    message: string;
  };
};

export const loginViewTranslation: LoginViewTranslation = {
  title: 'Kliknij, aby przejść dalej',
  loading: 'Trwa logowanie...',
  buttons: {
    start: 'Zacznijmy!',
    continue: 'Kontynuuj',
    login: 'Zaloguj się'
  },
  toast: {
    loginError: 'Błąd logowania',
    unknownError: 'Wystąpił nieoczekiwany błąd. Prosimy spróbować ponownie.',
  },
  welcomeFirst: {
    title: 'Witaj! Dobrze, że jesteś.',
    message: 'Nie traćmy czasu. Zacznijmy grę rekrutacyjną.'
  },
  welcomeAdmin: {
    title: 'Witaj!',
    message: 'Zaloguj się jako administrator.'
  },
  welcomeAgain: {
    title: 'Dobrze, że znów tu jesteś.',
    message: 'Już myślałem, że straciłem z Tobą kontakt. Nie traćmy czasu. Możesz kontynuować grę rekrutacyjną.'
  }
};
